// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"6c359117","84":"a946c144","620":"b9092de9","836":"79cac8f0","845":"8b3c1e07","874":"58b74980","936":"7071ca96","980":"ef4e53a0"}[chunkId] + ".chunk.js";
};